import { render, staticRenderFns } from "./PollManagerParent.vue?vue&type=template&id=b59f95a8&scoped=true&"
import script from "./PollManagerParent.vue?vue&type=script&lang=js&"
export * from "./PollManagerParent.vue?vue&type=script&lang=js&"
import style0 from "./PollManagerParent.vue?vue&type=style&index=0&id=b59f95a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f95a8",
  null
  
)

export default component.exports